import { FunctionComponent } from "react";
import { composeClasses } from "@kaltura/mediaspace-shared-styled";
import { HeaderLogo, HeaderLogoProps } from "../header/HeaderLogo/HeaderLogo";
import { FooterClasses, getFooterClass } from "./footerClasses";
import {
    StyledBottomContainer,
    StyledBottomContent,
    StyledBottomText,
    StyledFooter,
    StyledFooterContainer,
    StyledFooterContent,
    StyledFooterWrapper,
    StyledLinksAndTextContainer,
} from "./styledComponents";
import { ButtonAnalyticsProvider } from "@kaltura/mediaspace-shared-hooks";
import SocialLinks, { SocialLink } from "./social-links/SocialLinks";
import TextAndLinks, { TextAndLink } from "./text-and-links/TextAndLinks";
import Promotion, { PromotionSection } from "./promotion/Promotion";

export interface FooterProps {
    backgroundColor: string;
    backgroundUrl?: string;
    backgroundStretch?: boolean;
    promotion: PromotionSection;
    headerLogo: HeaderLogoProps;
    socialLinks?: SocialLink[];
    textAndLinks?: TextAndLink[];
    linkSeparator?: string;
    bottomText?: string;
    classes?: Partial<FooterClasses>;
}

const useUtilityClasses = (styleProps: Partial<FooterProps>) => {
    const { classes } = styleProps;

    const slots = {
        root: ["root"],
        image: ["image"],
        logo: ["logo"],
        promotion: ["promotion"],
        title: ["title"],
        text: ["text"],
        button: ["button"],
        bottomText: ["bottomText"],
        link: ["link"],
        socialIcon: ["socialIcon"],
        socialLinks: ["socialLinks"],
        content: ["content"],
        bottomContainer: ["bottomContainer"],
        bottomContent: ["bottomContent"],
        textAndLinks: ["textAndLinks"],
        separator: ["separator"],
        linkWrapper: ["linkWrapper"],
    };

    return composeClasses(slots, getFooterClass, classes);
};

export const Footer: FunctionComponent<FooterProps> = ({
    backgroundColor,
    backgroundUrl,
    backgroundStretch,
    promotion,
    headerLogo,
    socialLinks,
    textAndLinks,
    linkSeparator,
    bottomText,
    classes: classesProp,
}) => {
    const classes = useUtilityClasses({ classes: classesProp });

    return (
        <ButtonAnalyticsProvider location={"footer"}>
            <StyledFooterWrapper className={classes.root}>
                <StyledFooterContainer
                    className={classes.image}
                    url={backgroundUrl}
                    color={backgroundColor}
                    backgroundStretch={backgroundStretch}
                >
                    <StyledFooter>
                        <StyledFooterContent className={classes.content}>
                            {promotion && <Promotion promotion={promotion} classes={classes} />}
                            <StyledBottomContainer className={classes.bottomContainer}>
                                {!!headerLogo && <HeaderLogo {...headerLogo} className={classes.logo} />}
                                <StyledBottomContent className={classes.bottomContent} headerLogoExist={!!headerLogo}>
                                    <StyledLinksAndTextContainer className={classes.textAndLinks}>
                                        <TextAndLinks
                                            linkSeparator={linkSeparator}
                                            items={textAndLinks}
                                            classes={classes}
                                        />
                                        <StyledBottomText variant="body2" className={classes.bottomText}>
                                            {bottomText}
                                        </StyledBottomText>
                                    </StyledLinksAndTextContainer>
                                    <SocialLinks
                                        socialLinks={socialLinks}
                                        className={classes.socialLinks}
                                        iconButtonClassName={classes.socialIcon}
                                    />
                                </StyledBottomContent>
                            </StyledBottomContainer>
                        </StyledFooterContent>
                    </StyledFooter>
                </StyledFooterContainer>
            </StyledFooterWrapper>
        </ButtonAnalyticsProvider>
    );
};
